export enum ClaimStatus {
    "Draft" = 1,
    "Submitted For Investigation" = 2,    
    "Under Level 2 Investigation" = 3,
    "Invalid" = 4,
    "PartValid" = 5,
    "Pending Approval" = 6,
    "Approved" = 7,
    "Rejected" = 8,
    "Cancelled" = 9,
    "Closed" = 10,
}